export const PET_DEFINITIONS: PetDefinition[] = [
  { name: "Baby mole", templeItemId: 12646, category: "group", hours: 33 },
  { name: "Prince black dragon", templeItemId: 12653, category: "group", hours: 25 },
  { name: "Kalphite princess", templeItemId: 12647, category: "group", hours: 60 },
  { name: "Pet dark core", templeItemId: 12816, category: "group", hours: 77 },
  { name: "Sraracha", templeItemId: 23495, category: "group", hours: 30 },
  { name: "Little nightmare", templeItemId: 24491, category: "group", hours: 187 },
  { name: "Scurry", templeItemId: 28801, category: "group", hours: 50 },
  { name: "Huberte", templeItemId: 30152, category: "group", hours: 47 },
  { name: "Bran", templeItemId: 30622, category: "group", hours: 100 },
  { name: "Yami", templeItemId: 30888, category: "group", hours: 10 },

  { name: "Rift guardian", templeItemId: 20665, category: "skilling", hours: 68 },
  { name: "Beaver", templeItemId: 13322, category: "skilling", hours: 111 },
  { name: "Rock golem", templeItemId: 13321, category: "skilling", hours: 118 },
  { name: "Baby chinchompa", templeItemId: 13324, category: "skilling", hours: 99 },
  { name: "Rocky", templeItemId: 20663, category: "skilling", hours: 18 },
  { name: "Tangleroot", templeItemId: 20661, category: "skilling", hours: 82 },
  { name: "Heron", templeItemId: 13320, category: "skilling", hours: 84 },
  { name: "Giant squirrel", templeItemId: 20659, category: "skilling", hours: 133 },
  { name: "Soup", templeItemId: 31283, category: "skilling", hours: 0 },
  { name: "Mr mcgroot", templeItemId: 16316, category: "skilling", hours: 0 },

  { name: "Pet kree'arra", templeItemId: 12649, category: "gwd", hours: 100 },
  { name: "Pet general graardor", templeItemId: 12650, category: "gwd", hours: 91 },
  { name: "Pet k'ril tsutsaroth", templeItemId: 12652, category: "gwd", hours: 77 },
  { name: "Pet zilyana", templeItemId: 12651, category: "gwd", hours: 77 },
  { name: "Nexling", templeItemId: 26348, category: "gwd", hours: 174 },

  { name: "Pet dagannoth rex", templeItemId: 12645, category: "dks", hours: 57 },
  { name: "Pet dagannoth prime", templeItemId: 12643, category: "dks", hours: 57 },
  { name: "Pet dagannoth supreme", templeItemId: 12644, category: "dks", hours: 57 },

  { name: "Pet smoke devil", templeItemId: 12648, category: "slayer", hours: 27 },
  { name: "Pet kraken", templeItemId: 12655, category: "slayer", hours: 30 },
  { name: "Hellpuppy", templeItemId: 13247, category: "slayer", hours: 46 },
  { name: "Abyssal orphan", templeItemId: 13262, category: "slayer", hours: 57 },
  { name: "Noon", templeItemId: 21748, category: "slayer", hours: 83 },
  { name: "Ikkle hydra", templeItemId: 22746, category: "slayer", hours: 100 },
  { name: "Nid", templeItemId: 29836, category: "slayer", hours: 33 },
  { name: "Gull", templeItemId: 31285, category: "slayer", hours: 0 },

  { name: "Vorki", templeItemId: 21992, category: "quest", hours: 88 },
  { name: "Muphin", templeItemId: 27590, category: "quest", hours: 83 },
  { name: "Wisp", templeItemId: 28246, category: "quest", hours: 95 },
  { name: "Butch", templeItemId: 28248, category: "quest", hours: 81 },
  { name: "Baron", templeItemId: 28250, category: "quest", hours: 83 },
  { name: "Lil'viathan", templeItemId: 28252, category: "quest", hours: 83 },
  { name: "Moxi", templeItemId: 30154, category: "quest", hours: 36 },
  { name: "Beef", templeItemId: 33124, category: "quest", hours: 0 },

  { name: "Tzrek-jad", templeItemId: 13225, category: "pvmMinigame", hours: 27 },
  { name: "Jal-nib-rek", templeItemId: 21291, category: "pvmMinigame", hours: 43 },
  { name: "Youngllef", templeItemId: 23757, category: "pvmMinigame", hours: 114 },
  { name: "Lil' creator", templeItemId: 25348, category: "pvmMinigame", hours: 28 },
  { name: "Smol Heredit", templeItemId: 28960, category: "pvmMinigame", hours: 40 },

  { name: "Pet chaos elemental", templeItemId: 11995, category: "wilderness", hours: 3 },
  { name: "Venenatis spiderling", templeItemId: 13177, category: "wilderness", hours: 51 },
  { name: "Callisto cub", templeItemId: 13178, category: "wilderness", hours: 43 },
  { name: "Vet'ion jr. ", templeItemId: 13179, category: "wilderness", hours: 51 },
  { name: "Scorpia's offspring", templeItemId: 13181, category: "wilderness", hours: 16 },

  { name: "Olmlet", templeItemId: 20851, category: "raids", hours: 403 },
  { name: "Lil' zik", templeItemId: 22473, category: "raids", hours: 179 },
  { name: "Tumeken's guardian", templeItemId: 27352, category: "raids", hours: 148 },

  { name: "Pet penance queen", templeItemId: 12703, category: "skillingMinigames", hours: 308 },
  { name: "Phoenix", templeItemId: 20693, category: "skillingMinigames", hours: 100 },
  { name: "Smolcano", templeItemId: 23760, category: "skillingMinigames", hours: 56 },
  { name: "Tiny tempor", templeItemId: 25602, category: "skillingMinigames", hours: 100 },
  { name: "Abyssal protector", templeItemId: 26901, category: "skillingMinigames", hours: 103 },

  { name: "Pet snakeling", templeItemId: 12921, category: "misc", hours: 91 },
  { name: "Chompy chick", templeItemId: 13071, category: "misc", hours: 2 },
  { name: "Skotos", templeItemId: 21273, category: "misc", hours: 65 },
  { name: "Herbi", templeItemId: 21509, category: "misc", hours: 96 },
  { name: "Bloodhound", templeItemId: 19730, category: "misc", hours: 286 },
  { name: "Quetzin", templeItemId: 28962, category: "misc", hours: 42 },
  { name: "Dom", templeItemId: 31130, category: "misc", hours: 0 },
  { name: "Maggot marquess", templeItemId: 33642, category: "misc", hours: 0 },
  { name: "Aggy", templeItemId: 16317, category: "misc", hours: 0 }
];

export type PetCategoryKey =
  | "group"
  | "skilling"
  | "gwd"
  | "dks"
  | "slayer"
  | "quest"
  | "pvmMinigame"
  | "wilderness"
  | "raids"
  | "skillingMinigames"
  | "misc";

export interface PetDefinition {
  name: string;
  templeItemId: number;
  category: PetCategoryKey;
  hours: number;
}
